import React, { useContext, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import MessageBox from "../layout/MessageBox";
import { Store } from "../../Store";
import jwt_decode from "jwt-decode";

export default function AdminProtectedRoute({ children }) {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, token } = state;

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    try {
      const decoded = jwt_decode(token);
      if (decoded?.exp && decoded.exp < Date.now() / 1000) {
        ctxDispatch({ type: "USER_SIGNOUT" });
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("permissions");
        navigate("/");
      }
    } catch (error) {
      ctxDispatch({ type: "USER_SIGNOUT" });
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("permissions");
      navigate("/");
    }
  }, [token, ctxDispatch, navigate]);

  if (!userInfo || !token) {
    return <Navigate to="/" />;
  }

  const role = userInfo?.role;
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role?.name?.toLowerCase();

  if (normalizedRole !== "admin") {
    return <MessageBox variant={"danger"}>Restricted</MessageBox>;
  }

  return children;
}
